import React, { useState, useEffect } from 'react'
import { Box, Select, Flex, Group, Button, Avatar, Text } from '@mantine/core'
import { useDispatch } from 'react-redux'
import { updateOrder } from '../../../../../services/orders'
import { getListUsers } from '../../../../../services/users'
import { useParams } from 'react-router-dom'
import { getOrderDetail } from '../../../../../store/orderDetail'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'
import { IconCheck } from '@tabler/icons-react'

const defaultVal = {
  sales_by: '',
}

const FormAdjustSales = ({ detail, onCloseForm }) => {
  const dispatch = useDispatch()
  const params = useParams()
  const orderId = params.order_id
  const [formData, setFormData] = useState(defaultVal)
  const [loadingForm, setLoadingForm] = useState(false)
  const [userList, setUserList] = useState([])
  const [searchSales, setSearchSales] = useState('')

  const submitSalesBy = async (form) => {
    setLoadingForm(true)
    const payload = {
      sales_by: form.sales_by === null ? null : Number(form.sales_by)
    }
    try {
      const response = await updateOrder(orderId, payload)
      if (response.success) {
        onCloseForm()
        dispatch(getOrderDetail(orderId))
        notificationSuccess('Update Order Successfully', 'This data has been updated')
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Order Error', `${errorMessage ? errorMessage : 'Please recheck your form'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  const handleGetListUsers = async (userId) => {
    const parameter = {
      'filter[id][is]': userId,
      'filter[name][like]': searchSales,
      'fields[user]': 'id,name,email,active',
      'page[num]': 1,
      'page[limit]': 8,
      'sort': '-created_at',
      'active': true
    }
    try {
      const response = await getListUsers(parameter)
      const dataUser = response.data.data
      const remapDataUser = dataUser.map((val) => {
        return {
          label: val.attributes.name,
          value: `${val.attributes.id}`,
          email: val.attributes.email
        }
      })
      setUserList(remapDataUser)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    handleGetListUsers()
    // eslint-disable-next-line
  }, [searchSales])

  useEffect(() => {
    if (detail) {
      handleGetListUsers(detail.id)
      handleSetForm(detail)
    }
    // eslint-disable-next-line
  }, [detail])

  const handleSetForm = (value) => {
    const dataDetail = {
      sales_by: `${value.id}`
    }
    setFormData(dataDetail)
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const renderUserOption = ({ option, checked }) => {
    return (
      <Group flex="1" align='center' gap="xs">
        <Flex gap='sm' align='center'>
          <Avatar variant='filled' name={option.label} radius="xl" size="sm" color='red' />
          <Box>
            <Text fz={12} fw='600' lineClamp={2}>{option.label}</Text>
            <Text fz={10} fw='500' c='gray.6' lineClamp={2}>{option.email}</Text>
          </Box>
        </Flex>
        {checked && <IconCheck style={{ marginInlineStart: 'auto' }} />}
      </Group>
    )
  }

  return (
    <Box>
      <Box mb='md'>
        <Select
          name='sales_by'
          value={formData.sales_by}
          label='Sales By'
          placeholder='Select user'
          data={userList}
          renderOption={renderUserOption}
          onChange={(val) => handleChangeForm('sales_by', val)}
          size='xs'
          searchable
          searchValue={searchSales}
          onSearchChange={setSearchSales}
          nothingFoundMessage="No User Found"
          clearable
        />
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitSalesBy(formData)}>{detail ? 'Change' : 'Update'}</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAdjustSales